import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const App = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("walmates-token");
    const isOffline = !navigator.onLine;

    if (token) {
      navigate("/music", { replace: true, hidePath: true });
    } else {
      if (isOffline) {
        alert("You're offline and not logged in. Please connect and sign in.");
      }
      navigate("/login", { replace: true, hidePath: true });
    }

    window.history.pushState(null, null, '/');
  }, [navigate]);

  return <div>Loading...</div>;
};

export default App;

